import axios from "axios";
import { API_URL } from "utils/constants";

export const uploadAgentAvatar = async (userId, avatar) => {
  var formData = new FormData();
  formData.append("avatar", avatar); // file.name
  const response = await axios({
    method: "post",
    baseURL: API_URL,
    url: `/v1/Upload/uploadAvatar`,
    data: formData,
    params: {
      userId,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
